module.exports = __webpack_public_path__ + "assets/media/level9-user-icon.2cb3f344.png";